var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,6 L18,6 L18,19.992516 C18,20.5489341 17.5510798,21 16.992516,21 L4.00748397,21 C3.45106594,21 3,20.5510798 3,19.992516 L3,6 Z M15,17.4903342 L15,9.50966585 C15,9.22247314 14.7761424,9 14.5,9 C14.2319336,9 14,9.22818517 14,9.50966585 L14,17.4903342 C14,17.7775269 14.2238576,18 14.5,18 C14.7680664,18 15,17.7718148 15,17.4903342 Z M11,17.4903342 L11,9.50966585 C11,9.22247314 10.7761424,9 10.5,9 C10.2319336,9 10,9.22818517 10,9.50966585 L10,17.4903342 C10,17.7775269 10.2238576,18 10.5,18 C10.7680664,18 11,17.7718148 11,17.4903342 Z M7,17.4903342 L7,9.50966585 C7,9.22247314 6.77614237,9 6.5,9 C6.23193359,9 6,9.22818517 6,9.50966585 L6,17.4903342 C6,17.7775269 6.22385763,18 6.5,18 C6.76806641,18 7,17.7718148 7,17.4903342 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,1 C8,0.44771525 8.44371665,0 8.99980749,0 L12.0001925,0 C12.5523709,0 13,0.443864822 13,1 L13,2 L8,2 L8,1 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,2.99895656 C2,2.44724809 2.45470893,2 2.9999602,2 L18.0000398,2 C18.5523026,2 19,2.44266033 19,2.99895656 L19,5 L2,5 L2,2.99895656 Z"
})))));
export default SvgTrash;